import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { PagedResponse, Result } from "../../types/Result";
import { Chat } from "../chat/type";
import { User } from "../user/type";

export type UserChatsData = {
  user: User | null;
  page: PagedResponse<Chat>;
};

/**
 * Kullanıcı detayındaki "Yazışmalar" sayfası: /api/chats/filters uç noktasını
 * grid'in sayfalama/sıralama/filtre parametreleriyle çağırır, üstüne
 * creatorId = kullanıcı filtresini ekler. Grid filtreleri 0'dan başlayarak
 * indekslendiği için kullanıcı filtresi boştaki ilk indekse yazılır.
 */
export const userChatsLoader: LoaderFunction = async ({ params, request }) => {
  const userId = params.id as string;
  const search = new URL(request.url).searchParams;

  if (!search.has("sort.field")) {
    search.set("sort.field", "creationTime");
    search.set("sort.sort", "desc");
  }
  if (!search.has("pageSize")) search.set("pageSize", "50");

  let nextIndex = 0;
  search.forEach((_, key) => {
    const m = /^filters\[(\d+)\]\./.exec(key);
    if (m) nextIndex = Math.max(nextIndex, Number(m[1]) + 1);
  });
  search.set(`filters[${nextIndex}].field`, "creatorId");
  search.set(`filters[${nextIndex}].operator`, "eq");
  search.set(`filters[${nextIndex}].value`, userId);

  const [pageRes, userRes] = await Promise.all([
    axiosApi.get<PagedResponse<Chat>>(`/api/chats/filters?${search}`),
    axiosApi
      .get<Result<User>>(`/api/users/${encodeURIComponent(userId)}`)
      .catch(() => null),
  ]);

  const data: UserChatsData = {
    user: userRes?.data.data ?? null,
    page: pageRes.data,
  };
  return data;
};
